import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import DevicesSettingsVideoView from './DevicesSettingsVideoView';

import { useConferenceState } from '@hooks/conferenceContext';
import { useCommunications } from '@core/communications/providers/CommunicationsProvider';

const DevicesSettingsVideo = () => {
  const [checkVideo, setCheckVideo] = useState(false);
  const { activeCameraDeviceId, activeMicroDeviceId, setActiveCameraDeviceId } =
    useConferenceState();
  const { cameraList } = useCommunications();

  const { t: translate } = useTranslation();

  return (
    <DevicesSettingsVideoView
      cameras={cameraList}
      translate={translate}
      selectedMicrophone={activeMicroDeviceId}
      selectedCamera={activeCameraDeviceId}
      selectCamera={setActiveCameraDeviceId}
      changingDevice={false}
      setCheckVideo={setCheckVideo}
      checkVideo={checkVideo}
    />
  );
};

export default DevicesSettingsVideo;
